import { render, staticRenderFns } from "./Econometro.vue?vue&type=template&id=1b82f58c&"
import script from "./Econometro.vue?vue&type=script&lang=js&"
export * from "./Econometro.vue?vue&type=script&lang=js&"
import style0 from "./Econometro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports